const injectActivePageHTML = (pages, activePageId, html) =>
  pages.map((page) => (page.id !== activePageId ? page : { ...page, html }));

export default injectActivePageHTML;
